import Swiper from './Swiper';
import { mergeSettings, writeNavigationButtons, writePagination } from './Functions';
import isLive from 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Variables/isLive';

const type = {
    image(slider, settings, nummberOfSlides) {
        let multipleSlides = nummberOfSlides > 1;
        let buttons = multipleSlides ? writeNavigationButtons({ slider }) : null;
        let pagination = multipleSlides ? writePagination({ slider }) : null;
        let options = mergeSettings({
            typeSettings: {
                autoplay: {
                    enabled: isLive && multipleSlides,
                    delay: 6000,
                },
                lazy: {
                    enabled: true,
                    loadPrevNext: true,
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: multipleSlides ? buttons.next : null,
                    prevEl: multipleSlides ? buttons.prev : null,
                },
                on: {
                    reachEnd: function () {
                        // Stop autoplay on the first slide after all slides were shown
                        this.autoplay.stop();
                    },
                },
                loop: multipleSlides,
                speed: 1500,
                preloadImages: false,
            },
            settings,
            nummberOfSlides,
        });
        new Swiper(slider, options);
    },
};

export default type;
